"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObject_1 = require("../AnimationObject");
var TextDocument_1 = require("./TextDocument");
var TextDataKeyFrame = (function (_super) {
    tslib_1.__extends(TextDataKeyFrame, _super);
    function TextDataKeyFrame(rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        _this.start = new TextDocument_1.TextDocument(_this._rawData.s, version);
        return _this;
    }
    Object.defineProperty(TextDataKeyFrame.prototype, "time", {
        get: function () {
            return this._rawData.t;
        },
        set: function (time) {
            this._rawData.t = time;
        },
        enumerable: true,
        configurable: true
    });
    return TextDataKeyFrame;
}(AnimationObject_1.AnimationObject));
exports.TextDataKeyFrame = TextDataKeyFrame;
//# sourceMappingURL=TextDataKeyFrame.js.map